<div mat-dialog-title>
    <h2>Atenção</h2>
</div>
<div mat-dialog-content>
    <p>{{ data }}</p>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button cdkFocusInitial color="primary" [mat-dialog-close]="true">
        Ok
      </button>
</div>